import { render } from "./BreadcrumbCustomer.vue?vue&type=template&id=69c0b68d&scoped=true"
import script from "./BreadcrumbCustomer.vue?vue&type=script&lang=js"
export * from "./BreadcrumbCustomer.vue?vue&type=script&lang=js"

import "./BreadcrumbCustomer.vue?vue&type=style&index=0&id=69c0b68d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c0b68d"]])

export default __exports__